import { useCallback, useEffect, useState } from 'react'

const POPUPS = ['FUNDS_INFO', 'DIRECT_PAYMENT_INFO'] as const
export type PopupId = typeof POPUPS[number]

export const VIEWED_POPUPS_KEY = 'VIEWED_POPUPS'

export const getViewedPopups = (): string[] => {
    const currentPopups = localStorage.getItem(VIEWED_POPUPS_KEY)
    return currentPopups ? JSON.parse(currentPopups) : []
}

export const setViewedPopups = (items: string[]) => {
    localStorage.setItem(VIEWED_POPUPS_KEY, JSON.stringify(items))
}

export const useViewedPopups = () => {
    const [viewedPopups, setViewedPopupsState] = useState<string[]>(
        getViewedPopups()
    )

    useEffect(() => {
        setViewedPopups(viewedPopups)
    }, [viewedPopups])

    const hasViewed = useCallback(
        (id: PopupId) => {
            return viewedPopups.includes(id)
        },
        [viewedPopups]
    )

    const setViewed = useCallback(
        (id: PopupId) => {
            if (viewedPopups.includes(id)) return
            setViewedPopupsState((current) => [...current, id])
        },
        [viewedPopups]
    )

    return { hasViewed, setViewed }
}
